import {mapState} from 'pinia';
import {useTitle} from '@store/titleStore';

export default {
  computed: {
    ...mapState(useTitle, ['titleStore']),
    titleLocal() {
      if (this.title) {
        return this.$i18n.t(this.title);
      }
      if (!this.titleStore) {
        return '';
      }
      return this.$i18n.t(this.titleStore);
    },
  },
};
